<template>
  <div :class="[baseClass, customClass]">
    <div class="header">
      <h2>
        {{ user.headerSlogan }}
      </h2>
    </div>
    <div class="sub-header">
      <h3 v-html="$t('lps.talk_with', {name: user.name})" />
      <p>
        {{ user.headerSubSlogan }}
      </p>
    </div>
    <div class="profile">
      <img
        :src="user.image"
        :alt="user.name"
        class="profile-image"
        @click="$emit('nextCarousel')"
      >
      <div class="profile-username">
        <h2>{{ user.name }}, {{ user.age }}</h2>
        <div class="d-flex align-items-end">
          <span class="fs-14" style="padding-bottom: 4px">
            +4
          </span>
          <div class="profile-images">
            <img
              src="../../assets/images/lps/profile-images.png"
              alt="profiles"
              class="wh-60 w-76"
            >
            <img
              :src="user.image"
              :alt="user.name"
              class="border-white wh-60"
            >
          </div>
        </div>
      </div>
      <div class="icon-bar">
        <div class="icon">
          <img @click="updateActiveStep(2)" src="../../assets/images/lps/icon-heart.png" alt="heart" class="cursor-pointer">
        </div>
        <div class="icon">
          <img @click="updateActiveStep(2)" src="../../assets/images/lps/icon-gift.png" alt="gift" class="cursor-pointer">
        </div>
        <div class="icon">
          <img @click="updateActiveStep(2)" src="../../assets/images/lps/icon-dots.png" alt="dots" class="cursor-pointer">
        </div>
      </div>
    </div>
    <div class="sub-profile">
      <div>
        <img :src="user.image" :alt="user.name" class="profile-image-circle">
      </div>
      <div class="online-status">
        <span>{{ user.name }}, {{ user.age }}</span>
        <div class="d-flex align-items-center">
          <div class="online-dot"></div>
          <div class="online-status-text">
            ONLINE
          </div>
        </div>
      </div>
    </div>
    <div class="bio">
      <p>
        {{ user.bio }}
      </p>
    </div>
    <div class="action-buttons">
      <button @click="updateActiveStep(2)" class="action-btn btn-message">
        <img src="../../assets/images/lps/icon-message.png" alt="message" height="20">
        <span>
          {{ $t('Message') }}
        </span>
      </button>
      <button @click="updateActiveStep(2)" class="action-btn btn-video">
        <img src="../../assets/images/lps/icon-camera.png" alt="camera" height="20">
        <span>
          {{ $t('With Video') }}
        </span>
      </button>
      <button @click="updateActiveStep(2)" class="action-btn btn-voice">
        <img src="../../assets/images/lps/icon-call.png" alt="call" height="20">
        <span>
          {{ $t('With Voice') }}
        </span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LpUserCard',
  props: {
    customClass: {
      type: String,
      required: false,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      baseClass: null,
    }
  },
  methods: {
    updateActiveStep(step = 2) {
      this.$emit('updateActiveStep', step)
    },
  },
}
</script>
